import React from 'react'

import { default as AntButton } from 'antd/lib/button'
import 'antd/lib/button/style/index.less'

const Button = (props) => {
  return (
    <AntButton size="large" { ...props }>
      {props.children}
    </AntButton>
  )
}

export default Button
